



import NotificationProvider from 'context/notification_context';
import './styles/components.css';
import './styles/styles.css';




import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AnswersView from 'views/anwers_view';

// import AuthContextProvider from './context/auth_context';

// import NotificationProvider from './context/notification_context';
// import NotificationHolder from './components/nu_notification_holder';


import Home from 'views/home/home';
import NuevaDinamicaView from 'views/nueva_dinamica_view';

import QuestionView from 'views/question_view';
import NotificationHolder from 'components/notification_holder';
import LoginView from 'views/login';
import RewardsView from 'views/rewards_view';

function App() {

  
 
  return (
   
      <BrowserRouter>
        <NotificationProvider>
            {/* <AuthContextProvider> */}
            <NotificationHolder></NotificationHolder>

          
                <Routes>
                  
                    <Route path="/" element={<LoginView></LoginView>}/>
                    <Route path="/home" element={<Home></Home>}/>
                    <Route path="/dinamica" element={<NuevaDinamicaView></NuevaDinamicaView>}/>
                    <Route path="/question/:id_activity" element={<QuestionView></QuestionView>}/>
                    <Route path="/answer/:id_activity/:id_question" element={<AnswersView></AnswersView>}/>
                    <Route path="/rewards" element={<RewardsView></RewardsView>}/>

                    {/* <Route path="/" element={<LoginView></LoginView>}/>
               
                    <Route path="/register/:user_type" element={<RegisterView></RegisterView>}/>
                    <Route path="/register/clinica" element={<RegisterClinicaView></RegisterClinicaView>}/>
                    <Route path="/register/enfermeria" element={<RegisterEnfermeria></RegisterEnfermeria>}/>
                    <Route path="/register/estudiante" element={<RegisterEstudiante></RegisterEstudiante>}/>
                    <Route path="/register/tcae" element={<RegisterTCAE></RegisterTCAE>}/>
                    
                    <Route exact path="/profesional/*" element={
                     <GlobalContextProvider>
                      <PorfesionalNavigator></PorfesionalNavigator>
                     </GlobalContextProvider>} />
                    <Route exact path="/clinic/*" element={
                     <GlobalContextProvider>
                      <ClinicNavigator></ClinicNavigator>
                    </GlobalContextProvider>
                    } />
                    <Route exact path="/admin/*" element={
                    <AdminContextProvider>
                      <AdminNavigator></AdminNavigator>
                    </AdminContextProvider>} /> */}
                </Routes> 
           

            {/* </AuthContextProvider> */}
          </NotificationProvider>
      </BrowserRouter>

  )

}

export default App;
// import React from 'react'
// import { BrowserRouter as Router, Routes, Route } from 'react-router'

// import Home from 'views/home/home'

// const App = () => {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/home" element={<Home />} />
//       </Routes>
//     </Router>
//   )
// }

// export default App
